export const EMAIL_CATEGORIES = [
    'Account access',
    'Billing',
    'Technical issue',
    'General question',
] as const;